import { RoutePage } from "../../shared/route-page";

export class ComponentPage extends RoutePage{
  renderTitle() {
    return this.options.config.title ?? this.options.name;
  }
}